import { combineReducers } from "redux";
import auth from "./authReducer";
import admin from "./adminReducer";
import notify from "./notifyReducer";

const rootReducer = combineReducers({
  authReducer: auth,
  adminReducer: admin,
  notifyReducer: notify,
});

export default rootReducer;
